import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function SaveAsIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6659 3H8C5.79086 3 4 4.79086 4 7V17C4 18.9528 5.39935 20.5787 7.25 20.9298V18C7.25 16.4812 8.48122 15.25 10 15.25H14C15.5188 15.25 16.75 16.4812 16.75 18V20.9298C18.6006 20.5787 20 18.9528 20 17V9.55295C20 8.55397 19.6262 7.59115 18.9521 6.85388L16.618 4.30092C15.8602 3.4721 14.7889 3 13.6659 3ZM9 6.25C8.58579 6.25 8.25 6.58579 8.25 7C8.25 7.41421 8.58579 7.75 9 7.75H15C15.4142 7.75 15.75 7.41421 15.75 7C15.75 6.58579 15.4142 6.25 15 6.25H9Z"
        fill="currentColor"
      />
      <path
        d="M15.25 18V21H8.75V18C8.75 17.3096 9.30964 16.75 10 16.75H14C14.6904 16.75 15.25 17.3096 15.25 18Z"
        fill="currentColor"
      />
    </svg>
  )
}
